// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uag-profile-card {
  background: rgba(52, 52, 57, 0.6);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  margin-left: 20px;
}

.ug-profile {
  width: 90%;
  height: 50%;
  background: none;
  padding: 10px;
}

.ug-image {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

.ug-details {
  width: 100%;
  height: 40%;
  background: none;
  padding: 10px;
}

.ug-details h4 {
  margin: 5px 0;
  font-size: 16px;
  font-weight: bold;
}

.ug-details p {
  font-size: 14px;
}

.ug-profile-action {
  background: none;
  width: 100%;
  margin-top: 30px;
  align-content: center;
  height: 100%;
  margin-left: 20px;
  gap: 5px;
  align-items: center;
  justify-content: center;
  justify-self: center;
}

.uag-action-btn {
  width: 40px;
  height: 40px;
  margin-left: 10px;
  background: none;
  color: white;  
}

/* .uag-action-btn.hover {
  transform: scale(1.5);
} */

.ug-top-action-btn {
  width: 80;
  height: 20;
}

/* .ug-top-action-btn.hover {
  background: green;
} */

.ug-group-content {
  width: 90%;
  height: 130px;
  display: flex;
  flex-direction: column;
  text-align: center;
  font-family: "Switzer";
  /* font-weight: bold; */
  font-size: 15px;
  gap: -5px;
  margin-top: 20px;
  margin-left: 12px;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Components/Group/Styles/GroupGridCentreLowerLayout.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;GAEG;;AAEH;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;;GAEG;;AAEH;EACE,UAAU;EACV,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":[".uag-profile-card {\n  background: rgba(52, 52, 57, 0.6);\n  backdrop-filter: blur(10px);\n  border-radius: 12px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  margin-left: 20px;\n}\n\n.ug-profile {\n  width: 90%;\n  height: 50%;\n  background: none;\n  padding: 10px;\n}\n\n.ug-image {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.ug-details {\n  width: 100%;\n  height: 40%;\n  background: none;\n  padding: 10px;\n}\n\n.ug-details h4 {\n  margin: 5px 0;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.ug-details p {\n  font-size: 14px;\n}\n\n.ug-profile-action {\n  background: none;\n  width: 100%;\n  margin-top: 30px;\n  align-content: center;\n  height: 100%;\n  margin-left: 20px;\n  gap: 5px;\n  align-items: center;\n  justify-content: center;\n  justify-self: center;\n}\n\n.uag-action-btn {\n  width: 40px;\n  height: 40px;\n  margin-left: 10px;\n  background: none;\n  color: white;  \n}\n\n/* .uag-action-btn.hover {\n  transform: scale(1.5);\n} */\n\n.ug-top-action-btn {\n  width: 80;\n  height: 20;\n}\n\n/* .ug-top-action-btn.hover {\n  background: green;\n} */\n\n.ug-group-content {\n  width: 90%;\n  height: 130px;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  font-family: \"Switzer\";\n  /* font-weight: bold; */\n  font-size: 15px;\n  gap: -5px;\n  margin-top: 20px;\n  margin-left: 12px;\n  border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
